import { render, staticRenderFns } from "./EwayBill.vue?vue&type=template&id=627a0f80&"
import script from "./EwayBill.vue?vue&type=script&lang=js&"
export * from "./EwayBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports